import { Box, FormControl, IconButton } from '@mui/material';
import CustomSelect from 'app/components/CustomSelect';
import CustomInput from 'app/components/CustomInput';
import CustomSwitch from 'app/components/CustomSwitch';
import React, { useState } from 'react';
import BankCodeIcon from 'app/components/Icons/BankCodeIcon';
import BankDataModal from 'app/components/AccordionTypes/Country/BankDataModal';
import logger from 'app/utils/logger';
import FieldError from 'app/components/FieldError';

interface Props {
  register?: any;
  errors?: any;
  control?: any;
  budgetLevelCodes?: any;
  handleChangeSelectedBudgetValue?: any;
  selectedBudgetLevelCodes?: any;
  orgOpen?: any;
  orgClose?: any;
  transferData?: any;
  setIsSearch?: any;
  getOrgData?: any;
  bankCode?: any;
  clickOrgCode?: any;
  budgetOrgCodeChange?: any;
  dataForm?: any;
  budgetClassCode?: any;
  classCodeBudget?: any;
  dataOrganization?: any;
  dataClassification?: any;
  budgetIban?: any;
}

const GeneralDetailsBudget = (props: Props) => {
  const {
    register,
    control,
    errors,
    budgetLevelCodes,
    handleChangeSelectedBudgetValue,
    selectedBudgetLevelCodes,
    orgOpen,
    orgClose,
    transferData,
    setIsSearch,
    getOrgData,
    bankCode,
    clickOrgCode,
    budgetOrgCodeChange,
    budgetClassCode,
    classCodeBudget,
    dataOrganization,
    dataClassification,
    dataForm,
    budgetIban,
  } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Büdcə hesabının nömrəsi'}
            placeholder={'Büdcə hesabının nömrəsi'}
            rest={{ ...register('budgetAccNumber'), maxLength: 28 }}
            handleChange={budgetOrgCodeChange}
            isValid={
              errors.budgetAccNumber !== undefined ||
              dataOrganization?.error?.fields.organization !== undefined ||
              dataForm?.error?.fields.organization !== undefined
            }
            value={budgetIban}
          />
          <FieldError
            error={
              errors.budgetAccNumber
                ? errors.budgetAccNumber
                : dataOrganization?.error?.fields.organization
                ? {
                    message: dataOrganization?.error?.fields.organization,
                  }
                : dataForm?.error?.fields.organization && { message: dataOrganization?.error?.fields.organization }
            }
          />
        </FormControl>
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Təşkilatın adı'}
            placeholder={'Təşkilatın adı'}
            disabled={true}
            rest={{ ...register('orgName') }}
          />
        </FormControl>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Təşkilatın VÖEN-İ'}
            placeholder={'Təşkilatın VÖEN-İ'}
            disabled={true}
            rest={{ ...register('orgVoen') }}
          />
        </FormControl>
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomSelect
            title={'Səviyyə kodu'}
            placeholder={'Səviyyə kodu'}
            options={budgetLevelCodes}
            control={control}
            rest={{ ...register('levelCode') }}
            onChange={handleChangeSelectedBudgetValue}
            value={selectedBudgetLevelCodes}
            isValid={errors.levelCode}
          />
          <FieldError error={errors.levelCode} />
        </FormControl>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Təsnifat kodu'}
            placeholder={'Təsnifat kodu'}
            adornment={
              <IconButton onClick={() => orgClose(true)}>
                <BankCodeIcon />
              </IconButton>
            }
            handleChange={budgetClassCode}
            rest={{ ...register('classCode'), maxLength: 6 }}
            isValid={
              errors.classCode ||
              dataClassification?.error?.fields.classification_codes !== undefined ||
              dataForm?.error?.fields.classification_codes !== undefined
            }
            value={classCodeBudget}
          />
          <FieldError
            error={
              errors.classCode
                ? errors.classCode
                : dataClassification?.error?.fields.classification_codes
                ? {
                    message: dataClassification?.error?.fields.classification_codes,
                  }
                : dataForm?.error?.fields.classification_codes && {
                    message: dataForm?.error?.fields.classification_codes,
                  }
            }
          />
        </FormControl>
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Təsnifat adı'}
            placeholder={'Təsnifat adı'}
            disabled={true}
            rest={{ ...register('className') }}
          />
        </FormControl>
        {orgOpen && (
          <BankDataModal
            getCodeData={getOrgData}
            codeData={bankCode}
            dialogOpen={orgOpen}
            dialogSet={orgClose}
            transferData={transferData}
            clickCode={clickOrgCode}
            setIsSearch={setIsSearch}
            budget={true}
          />
        )}
      </Box>
    </Box>
  );
};

export default GeneralDetailsBudget;
